import axios from 'axios'
import _get from 'lodash/get'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const ADD_REASON = 'ADD_REASON'
export const RECEIVE_REASONS = 'RECEIVE_REASONS'
export const REMOVE_REASON = 'REMOVE_REASON'
export const REQUEST_REASONS = 'REQUEST_REASONS'

export const requestReasons = (selfAssessmentId) => (dispatch) => {
    dispatch({ type: REQUEST_REASONS, data: { selfAssessmentId } })

    axios
        .get(`/selfassessment/${selfAssessmentId}/reasons`)
        .then((response) => {
            const data = _get(response, ['data'], [])
            dispatch(receiveReasons({ activeReasons: data, fetchSuccessful: true }))
        })
        .catch((error) => {
            dispatch(receiveReasons({ fetchSuccessful: false }))

            dispatch(handleRequestError(error))
        })
}

export const receiveReasons = (data) => ({ type: RECEIVE_REASONS, data })

export const addReason = (reason) => (dispatch, getState) => {
    dispatch({ type: ADD_REASON, data: { reason } })

    const { assessment } = getState()

    axios
        .put(`/selfassessment/${assessment.id}/reason`, JSON.stringify(reason), {
            headers: { 'Content-Type': 'text/json' },
        })
        .then((response) => {
            const data = _get(response, ['data'], [])
            dispatch(receiveReasons({ activeReasons: data }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
        })
}

export const removeReason = (reason) => (dispatch, getState) => {
    dispatch({ type: REMOVE_REASON, data: { reason } })

    const { assessment } = getState()

    axios
        .delete(`/selfassessment/${assessment.id}/reason`, {
            headers: { 'Content-Type': 'text/json' },
            data: JSON.stringify(reason),
        })
        .then((response) => {
            const data = _get(response, ['data'], [])
            dispatch(receiveReasons({ activeReasons: data }))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) return

            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
        })
}
